import {
  Component,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewEncapsulation,
} from '@angular/core';

@Component({
  encapsulation: ViewEncapsulation.None,
  host: { class: 'pulse-header' },
  selector: 'pulse-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() userInfo: any;
  @Input() showUserPlan: boolean;
  @Input() showMyAccount: boolean

  @Output() closeSessionEvent = new EventEmitter<boolean>();
  @Output() searchEvent = new EventEmitter<any>();
  @Input() applicationName = 'Platform';
  @Input() showSearchPanel = true;

  selector: boolean = false;
  selectorDropdown() {
    this.selector = !this.selector;
  }
  selected: string = 'Collections';
  isToggle: number = 1;
  constructor() {}

  ngOnInit(): void {}

  search(event: string) {
    this.searchEvent.emit(event);
  }

  getPlan() {
    switch (this.userInfo.subscriptionType) {
      case 'P':
        return 'Premium';
      case 'B':
        return 'Basic';
      case 'F':
      default:
        return 'Free';
    }
  }

  closeSession() {
    this.closeSessionEvent.emit();
  }
}
